import type { FC } from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  iconOn: React.ReactNode;
  iconOff: React.ReactNode;
  isOn: boolean;
  onToggle: (e?: any) => void;
  size: "small" | "medium" | "large";
  tabIndex?: number;
  disabled?: boolean;
}

const ButtonStyle = styled.button<{
  size: "small" | "medium" | "large";
  isOn: boolean;
}>`
  width: ${(props) =>
    props.size === "small"
      ? "24px"
      : props.size === "medium"
        ? "36px"
        : "44px"};
  height: ${(props) =>
    props.size === "small"
      ? "24px"
      : props.size === "medium"
        ? "36px"
        : "44px"};
  background-color: ${(props) =>
    props.isOn ? theme.colors.primary : theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${theme.shadow.cardShadow};
  border-radius: 4px;

  &:hover {
    cursor: pointer;
    filter: opacity(0.6);
  }

  & > svg {
    flex-shrink: 0;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.disabled};
    color: white;
  }
`;

const ToggleButton: FC<Props> = ({
  iconOn,
  iconOff,
  isOn,
  onToggle,
  size,
  tabIndex,
  disabled,
}) => {
  return (
    <ButtonStyle
      size={size}
      isOn={isOn}
      onClick={onToggle}
      aria-pressed={isOn}
      tabIndex={tabIndex}
      disabled={disabled}
    >
      {isOn ? iconOn : iconOff}
    </ButtonStyle>
  );
};

export default ToggleButton;
